import { render, staticRenderFns } from "./CategoryDialog.vue?vue&type=template&id=22fffb04&scoped=true"
import script from "./CategoryDialog.vue?vue&type=script&lang=js"
export * from "./CategoryDialog.vue?vue&type=script&lang=js"
import style0 from "./CategoryDialog.vue?vue&type=style&index=0&id=22fffb04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fffb04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22fffb04')) {
      api.createRecord('22fffb04', component.options)
    } else {
      api.reload('22fffb04', component.options)
    }
    module.hot.accept("./CategoryDialog.vue?vue&type=template&id=22fffb04&scoped=true", function () {
      api.rerender('22fffb04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/storeCategory/components/CategoryDialog.vue"
export default component.exports